import { heroStats, synopsisParagraphs } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20night%20cityscape%20with%20glowing%20crimson%20and%20gold%20light%20trails%20and%20soft%20bokeh%20dots%2C%20moody%20elegant%20atmosphere%2C%20deep%20shadows%20with%20warm%20highlights%2C%20stylized%20artistic%20illustration%2C%20luxury%20short%20drama%20poster%20background%2C%20no%20text&width=1920&height=1080&seq=desire-hero-night&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/80 via-primary-950/60 to-primary-950/85" aria-hidden="true" />

      <div className="relative z-10 w-full px-4 md:px-6 pt-32 md:pt-40 pb-16">
        <div className="max-w-5xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/40 text-accent-200 text-xs md:text-sm font-label">
            <i className="ri-movie-2-line" aria-hidden="true" />
            都市情感短剧 · 全集浏览索引
          </span>

          <h1 className="mt-5 font-heading text-4xl md:text-6xl font-bold text-background-50 leading-tight">
            欲望的诱惑
          </h1>
          <p className="mt-3 font-heading text-lg md:text-2xl text-accent-200">
            短剧全集 · 全集免费看 · 短剧大合集
          </p>

          <p className="mt-5 max-w-2xl text-sm md:text-base text-background-100/90 leading-relaxed">
            {synopsisParagraphs[0]}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#episodes"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-600 text-primary-50 font-label text-sm md:text-base whitespace-nowrap hover:bg-primary-700 transition-colors"
            >
              <i className="ri-play-list-2-line" aria-hidden="true" />
              查看全部剧集
            </a>
            <a
              href="#themes"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-100/40 text-background-50 font-label text-sm md:text-base whitespace-nowrap hover:bg-background-50/10 transition-colors"
            >
              <i className="ri-sparkling-line" aria-hidden="true" />
              浏览核心看点
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl">
            {heroStats.map((s) => (
              <div key={s.label} className="rounded-lg border border-background-100/20 bg-background-50/5 px-4 py-3">
                <dt className="text-xs text-background-200/80 font-label">{s.label}</dt>
                <dd className="mt-1 font-heading text-xl md:text-2xl text-background-50">
                  {s.value}
                  <span className="ml-1 text-sm text-accent-300">{s.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}